import { render, staticRenderFns } from "./GenericHelpPopup.vue?vue&type=template&id=bcbfaaba&scoped=true&"
import script from "./GenericHelpPopup.vue?vue&type=script&lang=js&"
export * from "./GenericHelpPopup.vue?vue&type=script&lang=js&"
import style0 from "./GenericHelpPopup.vue?vue&type=style&index=0&id=bcbfaaba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbfaaba",
  null
  
)

export default component.exports